import FormattedMessage from 'I18n/components/FormattedMessage';
import { DISABLED_ADD_OPTION_REASONS } from 'FormsUI/constants/Payments';
import { jsx as _jsx } from "react/jsx-runtime";
const DisableAddOptionReason = ({
  reason
}) => {
  switch (reason) {
    case DISABLED_ADD_OPTION_REASONS.INVALID_ROW:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.options.payment.options.disableReason.invalidRow"
      });
    case DISABLED_ADD_OPTION_REASONS.NO_MORE_OPTIONS_REMAINING:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.options.payment.options.disableReason.noMoreOptions"
      });
    default:
      return null;
  }
};
export default DisableAddOptionReason;